
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipment-calculator",
      function () {
        return require("private-next-pages/shipment-calculator/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipment-calculator"])
      });
    }
  